<template>
  <div id="xxx_main">
    <div class="nav-top">
      <div class="nav-left">
        <img src="../assets/img/返回箭头.png" class="nav-img" @click="back()" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">个人主页</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../assets/img/发布.png" class="nav-img none" />
      </div>
    </div>

    <div class="box">
      <div class="ub info">
        <div class="ub ub-ver ub-pc">
          <img :src="user.photo" class="ub ub-ac ub-pc head_picture" />
          <div class="nick">{{user.nick }}</div>
        </div>

        <div class="ub ub-ver info_left_icon">
            <img v-if="user.sex=='女生'" src="../assets/img/女.png" class="sex_img">
            <img v-if="user.sex=='男生'" src="../assets/img/男.png" class="sex_img">
            <img src="../assets/img/位置.png" class="ub ub-ac ub-pc location_img">
        </div>

        <div class="info_left_font">
            <div class="ub ub-pc font_Sex_Age">
                <div class="ub ub-ac font_sex">{{user.sex}}</div>
                <div class="ub ub-ac font_Age">{{user.age_range}}</div>
              </div>
              <div class="ub ub-pc font_province_city">
                <div class="ub ub-ac font_province">{{user.loc_province}}</div>
                <div class="ub ub-ac font_city">{{user.loc_city}}</div>
              </div>
              <div class="ub div_label">
                <div v-for="(item,index) in user.inst_tag" :key="index" class="ub ub-ac ub-pc label">{{item}}</div>
              </div>
        </div>
      </div>

      <div class="ub value-block">
        <div class="ub-f1">
          <div class="ub ub-ac value-name">豪气值</div>
          <div class="ub ub-ac num color-1">{{user.coin_total}}</div>
        </div>

        <div class="ub-f1 border-rl">
          <div class="ub ub-ac value-name">魅力值</div>
          <div class="ub ub-ac num color-2">{{user.score_total}}</div>
        </div>

        <div class="ub-f1">
          <div class="ub ub-ac value-name">好友数</div>
          <div class="ub ub-ac num color-3">{{user.friend_num}}</div>
        </div>
      </div>

      <div class="middle-block">
        <div v-if="1==2" class="ub ub-pc menu-item">
          <span class="menu-name">认证微信:</span>
          <span class="wechat ub-ae">{{user.wx}}</span>
          <span class="look-btn">查看</span>
        </div>

        <div class="menu-line"></div>

        <div class="ub ub-pc menu-item">
          <span class="menu-name">最近在线:</span>
          <span class="menu-date">{{timediff}}前</span>
        </div>

        <div class="menu-line"></div>

        <div class="ub ub-pc menu-item" @click="goto_giftdtl()">
          <span class="menu-name">礼物墙:</span>
          <span>{{gift_total}}个</span>
          <img src="../assets/img/箭头.png" class="arrow-img" />
        </div>

        <div class="ub gift-block" v-for="(item, index) in ary_gift" :key="index">
          <div class="ub ub-f1 ub-ver ub-pc" v-for="sub_item in item" :key="sub_item.id">
            <img :src="sub_item.url" class="gift-img" />
            <span>×{{gift_sum[sub_item.name]}}</span>
          </div>
        </div>

      </div>

      <div class="height"></div>

      <div class="ub bottom-block" @click="goto_chat()">
        <span class="ub-f1 ub-ac ub-pc bot-item item-col-1">送礼物</span>
        <span class="ub-f1 ub-ac ub-pc bot-item item-col-2">加好友</span>
        <span class="ub-f1 ub-ac ub-pc bot-item item-col-3">发私信</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapActions } from "vuex";
  import * as tool from '../api/common';
  export default {
    data() {
      return {
        topic_uid: '',
        user: {
          photo: require('../assets/img/头像.jpg'),
          nick: "***",
          sex: "女生",
          age_range: "18-23岁",
          loc_province: "**省",
          loc_city: "**市",
          loc_area: "**区",
          inst_tag: ["***", "***"],
          coin_total:0,
          score_total:0,
          friend_num:0,
          wx:'暂无',
          wx_check:''
        },
        gift_sum:{
          "棒棒糖":0,
          "鲜花":0,
          "黄瓜":0,
          "啪啪啪":0,
          "杜蕾斯":0,
          "水晶拉珠":0,
          "珍珠T裤":0,
          "小怪兽":0,
          "香水":0,
          "包包":0,
          "钻戒":0,
          "水晶鞋":0,
          "皇冠":0,
          "法拉利":0,
          "飞机":0,
          "火箭":0,
          
          "中秋月饼":0,
          "小红旗":0
        },
        ary_gift:[],
        gift_total:0,
        timediff:'2天'
      };
    },

    mounted() {
      this.init_page();
    },

    methods: {
      ...mapMutations(["get", "post"]), //引入方法
      ...mapActions(["act_get_userinfo"]), //引入方法

      back() {
        this.$router.go(-1); //返回上一层
      },

      goto_giftdtl(){
        this.$router.push({ name: "my_gift" , params: { 'uid':this.topic_uid } });
      },
  
      goto_chat(){
        this.$router.push({ name: 'chart', params: { uid: this.topic_uid } });
      },

      init_page() {
        //接收参数
        if (this.$route.params.topic_uid) {
          this.topic_uid = this.$route.params.topic_uid;
          this.$store.commit('set_topic_uid', this.topic_uid);
        }
        else {
          this.topic_uid = this.$store.state.topic_uid;
        }

        //加载数据
        var self = this;
        self.act_get_userinfo({
          uid: this.topic_uid,
          success: function (u) {
            self.user.uid = u.uid;
            self.user.photo = u.photo;
            self.user.nick = u.nick.length > 6 ? u.nick.substr(0,5) + '...' : u.nick;
            self.user.sex = u.sex;
            self.user.age_range = u.age_range;
            self.user.loc_province = u.loc_province;
            self.user.loc_city = u.loc_city;
            self.user.loc_area = u.loc_area;
            self.user.inst_tag = u.inst_tag.split("|");
            self.user.coin_total = u.coin_total;
            self.user.score_total = u.score_total;
            self.user.friend_num = u.friend_num;
            self.user.wx = u.wx == '' ? '暂无绑定' : u.wx;
            self.user.wx_check = u.wx_check;
          }
        });

        self.get({
          url: '/App/GetGiftSum/?uid=' + this.topic_uid,
          success: function (data) {
            if(data){
               for(var i=0; i<data.length; i++){
                 if(data[i].gift_name == '棒棒糖' || data[i].gift_name == '中秋月饼' || data[i].gift_name == '小红旗'){
                  self.gift_sum['棒棒糖'] += data[i].c;
                  self.gift_sum['中秋月饼'] += data[i].c;
                  self.gift_sum['小红旗'] += data[i].c;
                  self.gift_total += data[i].c;
                 }
                 else{
                  self.gift_sum[data[i].gift_name] = data[i].c;
                  self.gift_total += data[i].c;
                 }
               }
            }
          }
        });

        //加载最近上线时间
        self.get({
          url: '/App/GetLeastOnline/?uid=' + this.topic_uid,
          success: function (data) {
            if(data){
               var dif = tool.dateDiff(new Date(data), new Date());
               self.timediff = dif;
            }
          }
        });

        var const_data = this.$store.state.const_data;
        this.ary_gift = tool.slice_arry(const_data.gift_1.concat(const_data.gift_2), 4);

      }

    }
  };
</script>

<style lang="scss" scoped>
  .box {
    background-color: #dcdcdc;
    .info {
      background-color: white;
      height: 7rem;
      padding: 0.8rem 0.8rem 0 0.8rem;
      .head_picture {
        width: 4rem;
        height: 4rem;
        background-color: #bcbcbc;
        border-radius: 50%;
      }
      .nick {
        color: #333;
        margin-top: 0.5rem;
        white-space: nowrap;
      }
      .info_left_icon {
        margin-left: 1.2rem;
        .sex_img {
          width: 1.4rem;
          height: 1.4rem;
          margin-top: 0.4rem;
        }
        .location_img {
          width: 1rem;
          height: 1rem;
          margin-left: 0.25rem;
          margin-top: 0.88rem;
        }
      }

      .info_left_font {
        margin-left: 0.5rem;
        .font_Sex_Age {
          height: 1.2rem;
          margin-top: 0.5rem;
        }

        .font_sex {
          height: 1.5rem;
          line-height: 1.5rem;
          color: #333;
        }

        .font_Age {
          justify-content: center;
          height: 1.5rem;
          line-height: 1.5rem;
          color: #333;
          margin-left: 0.8rem;
        }

        .font_province_city {
          height: 1.5rem;
          margin-top: 0.7rem;
        }

        .font_province {
          flex-shrink: 0;
          color: #333;
          line-height: 1.5rem;
        }

        .font_city {
          flex-shrink: 0;
          color: #333;
          line-height: 1.5rem;
          margin-left: 0.8rem;
        }
        .div_label {
          margin-top: 0.7rem;
          .label {
            display: inline-block;
            text-align: center;
            font-size: 0.75rem;
            height: 1rem;
            line-height: 1rem;
            padding: 0.3rem 0.5rem;
            border-radius: 0.3rem;
            background-color: #e92162;
            color: white;
            flex-shrink: 0;
            margin-right: 0.3rem;
          }
        }
      }
    }
  }

  .value-block {
    font-weight: bold;
    height: 5rem;
    background-color: white;
    border-top: solid 1px #dfdfdf;
    border-bottom: solid 1px #dfdfdf;
    .border-rl {
      border-left: solid 1px #dfdfdf;
      border-right: solid 1px #dfdfdf;
    }
    .value-name {
      height: 2rem;
      line-height: 2.3rem;
      color: #666;
    }
    .num {
      height: 3rem;
      line-height: 2rem;
      font-size: 1.2rem;
    }

    .color-1 {
      color: #ff900b;
    }

    .color-2 {
      color: #fa3970;
    }

    .color-3 {
      color: #1d885a;
    }
  }

  

  .middle-block {
    background-color: white;
    .menu-item {
      margin-left: 1.5em;
      height: 3rem;
      .menu-name {
        flex: 1;
        color: #666;
      }
      .wechat {
        margin-right: 1rem;
        color: #333;
      }
      .look-btn {
        border: solid 1px #e92162;
        width: 4.5rem;
        height: 2rem;
        line-height: 2rem;
        border-radius: 0.3rem;
        color: #e92162;
        font-size: 0.8rem;
        text-align: center;
        margin-right: 2rem;
      }
      .menu-date {
        color: #333;
        margin-right: 1.6rem;
      }
      .arrow-img {
        width: 1.25rem;
        height: 1.25rem;
        margin-right: 1.4rem;
      }
    }
    .gift-block {
      justify-content: space-around;
      height: 6.5rem;
      span {
        color: #e92162;
      }
      .gift-img {
        width: 3rem;
        height: 3.5rem;
      }
    }
  }

  .height {
    background-color: white;
    height: 3.5rem;
  }

  .bottom-block {
    border-top: solid 1px #dcdcdc;
    width: 100%;
    bottom: 0;
    position: fixed;
    background-color: white;
    .bot-item {
      height: 3.5rem;
      line-height: 3.5rem;
      text-align: center;
      color: white;
    }
    .item-col-1 {
      background-color: #e92162;
    }

    .item-col-2 {
      background-color: #0000ff;
    }

    .item-col-3 {
      background-color: #f38d07;
    }
  }
</style>